import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IButtonDecoratedTextBlok } from './button-decorated-text.model';

@Component({
    selector: 'app-button-decorated-text',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './button-decorated-text.component.html',
    styleUrl: './button-decorated-text.component.scss',
    host: { '[class]': 'getAllOuterClasses()' },
})
export class ButtonDecoratedTextComponent {
    private _tailwind = inject(TailwindService);

    block = input.required<IButtonDecoratedTextBlok>();

    getAllInnerClasses = computed<string[]>(() => {
        return this._tailwind.getTypographyClasses(this.block());
    });

    getAllOuterClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            'block', 'w-min', 'whitespace-nowrap', 'mx-auto',
            ...this._tailwind.getBackgroundColorClasses(block),
            ...this._tailwind.getBorderRadiusClasses(block),
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getDisplayClasses(block),
        ];
    });
}
